export const UserAuthRole = {
  Owner: 'owner',
  Viewer: 'viewer',
  SuperAdmin: 'super_admin',
} as const;

export type UserAuthRole = (typeof UserAuthRole)[keyof typeof UserAuthRole];

export const AuthUserTypeName = {
  SystemUser: 'system_user',
  BusinessUser: 'business_user',
} as const;

export type AuthUserTypeName = (typeof AuthUserTypeName)[keyof typeof AuthUserTypeName];

export const AuthAccountStatus = {
  Pending: 'pending',
  Active: 'active',
  Suspended: 'suspended',
  Deactivated: 'deactivated',
} as const;

export type AuthAccountStatus = (typeof AuthAccountStatus)[keyof typeof AuthAccountStatus];
